import { useQuery } from "@tanstack/react-query";

import { pessoaService } from "@/services/api/PessoaService";
import { PeriodoResumoAcessos, PessoaAcessoResumoDTO } from "@/types/pessoa-acesso.type";

export function usePessoaResumoAcessos(dias: PeriodoResumoAcessos) {
  const { data, isLoading, isError, refetch } = useQuery<PessoaAcessoResumoDTO>({
    queryKey: ["pessoa-resumo-acessos", dias],
    queryFn: () => pessoaService.getResumoAcessos(dias),
  });

  return {
    resumo: data ?? { acessosPorDia: [], totalAtivos: 0, acessaramHoje: 0 },
    loading: isLoading,
    isError,
    refetch,
  };
}
